var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.6656 0.00636077C117.057 0.00636801 150.665 33.6146 150.665 75.0059L150.665 150.005L75.6656 150.005C34.2742 150.005 0.665995 116.397 0.666003 75.0059C0.66601 33.6145 34.2742 0.00635353 75.6656 0.00636077Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.2775 47.2246C11.2468 47.2246 0.666313 36.6442 0.666313 23.6134V0.00225067H24.2775C37.3082 0.00225067 47.8887 10.5827 47.8887 23.6134C47.8887 36.6442 37.3082 47.2246 24.2775 47.2246Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7_2",
    d: "M21.1043 33.748L30.666 16.0723V13.748H16.916V15.9551H27.9691V16.1113L18.3666 33.748H21.1043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M93.4296 73.3105H56.2969V98.7541H93.4296V73.3105Z",
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M97.076 73.3105H59.9434V98.7541H97.076V73.3105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.4309 99.8412H56.2982C55.6991 99.8412 55.209 99.3511 55.209 98.752V73.3084C55.209 72.7094 55.6991 72.2192 56.2982 72.2192H93.4309C94.03 72.2192 94.5202 72.7094 94.5202 73.3084V98.752C94.5202 99.3511 94.03 99.8412 93.4309 99.8412ZM57.3875 97.6628H92.3417V74.3976H57.3875V97.6628Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M76.5344 55.4057L76.3819 55.3403L38.8789 72.7674L76.3819 85.6199L76.5344 85.5655L113.874 72.7674L76.5344 55.4057Z",
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.2493 57.7616L81.0968 57.6963L43.5938 75.1234L75.8644 85.4176L113.204 72.6196L81.2493 57.7616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.3835 86.707C76.2637 86.707 76.1439 86.6852 76.0349 86.6526L38.5319 73.7892C38.1071 73.6476 37.8239 73.2555 37.8021 72.8198C37.7803 72.3732 38.0308 71.9593 38.4339 71.7742L75.9151 54.3471C76.1983 54.2163 76.5251 54.2163 76.8083 54.3471L76.9608 54.4124H76.9826L114.333 71.7742C114.736 71.9593 114.987 72.3732 114.965 72.8198C114.943 73.2664 114.649 73.6476 114.235 73.7892L76.7321 86.6417C76.6231 86.6852 76.5033 86.6961 76.3835 86.6961V86.707ZM41.7888 72.6128L76.3726 84.4633L110.956 72.6128L76.3835 56.5363L41.7888 72.6128Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.1237 58.5872H45.5359C45.1527 58.5872 44.8516 58.287 44.8516 57.9049C44.8516 57.5229 45.1527 57.2227 45.5359 57.2227H47.1237C47.507 57.2227 47.8081 57.5229 47.8081 57.9049C47.8081 58.287 47.507 58.5872 47.1237 58.5872Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.5182 58.5872H49.9305C49.5472 58.5872 49.2461 58.287 49.2461 57.9049C49.2461 57.5229 49.5472 57.2227 49.9305 57.2227H51.5182C51.9015 57.2227 52.2026 57.5229 52.2026 57.9049C52.2026 58.287 51.9015 58.5872 51.5182 58.5872Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M48.5184 57.1964C48.1351 57.1964 47.834 56.8962 47.834 56.5141V54.9313C47.834 54.5492 48.1351 54.249 48.5184 54.249C48.9016 54.249 49.2028 54.5492 49.2028 54.9313V56.5141C49.2028 56.8962 48.9016 57.1964 48.5184 57.1964Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M48.5184 61.5763C48.1351 61.5763 47.834 61.2761 47.834 60.894V59.3112C47.834 58.9291 48.1351 58.6289 48.5184 58.6289C48.9016 58.6289 49.2028 58.9291 49.2028 59.3112V60.894C49.2028 61.2761 48.9016 61.5763 48.5184 61.5763Z",
    fill: "#C3A1F3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M100.201 54.1887L97.7402 56.6611L100.2 59.1344L102.66 56.662L100.201 54.1887Z",
    fill: "#F7D979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M100.219 59.5888C100.099 59.5888 99.9907 59.5405 99.9067 59.4561L97.4475 56.984C97.2675 56.8031 97.2675 56.5257 97.4475 56.3448L99.8948 53.8727C100.063 53.7039 100.363 53.7039 100.531 53.8727L102.99 56.3448C103.17 56.5257 103.17 56.8031 102.99 56.984L100.531 59.4561C100.447 59.5405 100.339 59.5888 100.219 59.5888ZM98.3952 56.6584L100.219 58.4914L102.042 56.6584L100.219 54.8254L98.3952 56.6584Z",
    fill: "#705699"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M103.568 108.468L97.3591 101.758L91.1504 108.468V96.9004V85.3223H97.3591H103.568V96.9004V108.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M104.659 111.245L97.3605 103.36L90.0625 111.245V84.2334H104.648V111.245H104.659ZM97.3605 100.147L102.48 105.68V86.4118H92.2519V105.691L97.3714 100.157L97.3605 100.147Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M107.513 85.1611C107.513 90.7704 102.97 95.3124 97.3608 95.3124C91.7512 95.3124 87.209 90.7704 87.209 85.1611C87.209 79.5517 91.7512 75.0098 97.3608 75.0098C102.97 75.0098 107.513 79.5517 107.513 85.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M97.3622 96.3994C91.1643 96.3994 86.1211 91.3565 86.1211 85.1589C86.1211 78.9614 91.1643 73.9185 97.3622 73.9185C103.56 73.9185 108.603 78.9614 108.603 85.1589C108.603 91.3565 103.56 96.3994 97.3622 96.3994ZM97.3622 76.0968C92.3625 76.0968 88.2996 80.1595 88.2996 85.1589C88.2996 90.1583 92.3625 94.221 97.3622 94.221C102.362 94.221 106.425 90.1583 106.425 85.1589C106.425 80.1595 102.362 76.0968 97.3622 76.0968Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M97.3619 92.4025C93.3643 92.4025 90.1074 89.1458 90.1074 85.1593C90.1074 81.1729 93.3643 77.9053 97.3619 77.9053C101.359 77.9053 104.605 81.162 104.605 85.1593C104.605 89.1567 101.359 92.4025 97.3619 92.4025Z",
    fill: "#F7D979"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M51.7134 84.3828H41.1367V86.5612H51.7134V84.3828Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M46.4305 88.979H41.1367V91.1574H46.4305V88.979Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M48.8054 101.793H47.1002C46.6886 101.793 46.3652 101.469 46.3652 101.056C46.3652 100.644 46.6886 100.32 47.1002 100.32H48.8054C49.217 100.32 49.5404 100.644 49.5404 101.056C49.5404 101.469 49.217 101.793 48.8054 101.793Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M53.5241 101.793H51.819C51.4074 101.793 51.084 101.469 51.084 101.056C51.084 100.644 51.4074 100.32 51.819 100.32H53.5241C53.9357 100.32 54.2591 100.644 54.2591 101.056C54.2591 101.469 53.9357 101.793 53.5241 101.793Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M50.3209 100.29C49.9093 100.29 49.5859 99.9663 49.5859 99.554V97.8604C49.5859 97.448 49.9093 97.124 50.3209 97.124C50.7325 97.124 51.0559 97.448 51.0559 97.8604V99.554C51.0559 99.9663 50.7325 100.29 50.3209 100.29Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M50.3209 105.017C49.9093 105.017 49.5859 104.693 49.5859 104.281V102.572C49.5859 102.16 49.9093 101.836 50.3209 101.836C50.7325 101.836 51.0559 102.16 51.0559 102.572V104.281C51.0559 104.693 50.7325 105.017 50.3209 105.017Z",
    fill: "#F58B93"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet7);
export default __webpack_public_path__ + "static/media/item_tablet_7.f78520ffdadb6d62a03a276046754e15.svg";
export { ForwardRef as ReactComponent };